import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { CargosProvider } from '../../providers/cargos/cargos'
import { cargos } from '../../models/cargos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'

import { UtilsProvider } from '../../providers/utils/utils'
import { NUBE_AWS } from '../../config/url.servicio';


@IonicPage()
@Component({
  selector: 'costosadicionales',
  templateUrl: 'costosadicionales.html',
  providers: [ AuthService ]
})
export class CostosadicionalesPage {

  nombre:string
  valor:string
  costosadicionales = []
  nombreCompaniaHeader:any=""
  nombreHeader:any=""
  exclusivoCambioFechaDePago:string = 'N'
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: CargosProvider ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public storages:Storage,
    public utils:UtilsProvider,
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombre'])
      .then((val)=>{
      if(val){
      this.nombreCompaniaHeader = val['nombreCompania']
      this.nombreHeader = val['nombre']
      }
      })

  }

  ionViewDidLoad() {
    this.cargarServicio()
  }

  cargarServicio() {
    this.storages.get('companiasId').then((val) => {
      this.servicio.buscarCostosAdicionales(val)
      .subscribe((data) => {
          this.costosadicionales =  JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data[0]
      }, error => {
        console.log(error)
      })
  })
  }

  guardar() {
    let datosCargo: any = {
      nombreCosto: this.nombre,
      valorCostoMensual: this.valor,
      exclusivoCambioFechaDePago:this.exclusivoCambioFechaDePago,
      queHago: "I",
      estado:'A',
      nombreTabla: "costosAdicionales",
      name: "dataDynamicCrud"
    }



    this.storages.get('companiasId').then(async (val) => {
      datosCargo['companiasId'] = val

      let datos = await this.servicio.validarCostosAdicionalesCambioFecha(val)
      let response = datos.json()
      if(response && response.data && response.data[0].length>0) {
        this.utils.mensajeMuestro('costos adicionales','ya existe un costo que Aplica al cambiar la fecha de pago, debe eliminar ese costo antes de ingresar uno nuevo','warning')
        this.limpiar()
        return
      }
      this.servicio.guardarCostosAdicionales(datosCargo)
      .subscribe(
        res => {
                  this.utils.mensajeMuestro('costos adicionales','Guardado Exitosamente!','success')
                  if(NUBE_AWS){
                    this.cargarServicio()
                  } else {
                    this.costosadicionales.push(res[0])
                  }
                },
        err => console.log(err)
      )
    })

    this.nombre = ""
    this.valor = ""
    this.exclusivoCambioFechaDePago = 'N'
  }

  limpiar() {
    this.nombre = ""
    this.valor = ""
    this.exclusivoCambioFechaDePago = 'N'
  }

  editarRegistros(originalTodo: cargos, modificadoTodo: cargos) {
    const index = this.costosadicionales.indexOf(originalTodo);
    this.costosadicionales = [
      ...this.costosadicionales.slice(0, index),
      modificadoTodo,
      ...this.costosadicionales.slice(index + 1)
    ]
    this.costosadicionales = []
    this.cargarServicio()
  }


  eliminar(todo: any) {
    this.utils.mensajeConfirmacionDos('datos adicionales','¿Está Seguro de borrar el registro?','question','Si','No')
     .then((loQuiereBorrar: boolean) => {
      if (loQuiereBorrar) {
        let costosadicionales = []
        costosadicionales['queHago'] = "E"
        costosadicionales['name'] = "dataDynamicCrud"
        costosadicionales['nombreTabla'] = "costosAdicionales"
        costosadicionales['costosAdicionalesId'] = todo.costosAdicionalesId
        this.servicio.eliminarCostosAdicionales(costosadicionales)
        .subscribe(
          res => {
            this.costosadicionales = []
            this.utils.mensajeMuestro('costos adicionales','Eliminado Exitosamente','success')
            this.cargarServicio();
          },
          err => console.log(err)
        )
      }
      else {
        this.utils.mensajeMuestro('costos adicionales','No se eliminó el registro','warning')
      }
    })
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/costosadicionales/costosadicionales.ts